import * as React from 'react';
import debounce from 'lodash/debounce';
import map from 'lodash/map';

interface UseScrollProps {
  ref?: React.MutableRefObject<HTMLTableSectionElement | undefined>;
  trigger: React.DependencyList;
  isActive: boolean;
}

let scrollTimeout: number | undefined;

export function useScrollListToBottom({ ref, trigger, isActive = true }: UseScrollProps): void {
  const handleResize = debounce(() => {
    scrollToBottom();
  }, 100);

  React.useEffect(() => {
    window.addEventListener('resize', handleResize);
    scrollToBottom();

    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(scrollTimeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useLayoutEffect(() => {
    scrollTimeout = window.setTimeout(scrollToBottom);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  function scrollToBottom() {
    const list = ref && ref.current;
    if (!list || !list.children.length) return;
    const [last] = map(list.children).slice(-1);
    isActive && last && last.scrollIntoView({ behavior: 'smooth' });
  }
}
